<template>
  <div>
    <div v-if="tiposComAlternativas.includes(pergunta.tipo)">
      <codemirror v-model="alternativasText" :options="codeOptions" />
      <small class="hint">Cada linha representa uma alternativa.</small>
    </div>

    <div v-else-if="pergunta.tipo === 'TEXT'">
      <input
        class="form-control"
        disabled
        placeholder="Resposta de texto livre"
      />
    </div>

    <div v-else-if="pergunta.tipo === 'TEXTAREA'">
      <textarea
        class="form-control"
        disabled
        placeholder="Resposta em texto longo"
      ></textarea>
    </div>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";

export default {
  name: "Alternativas",
  components: { codemirror },
  props: ["pergunta"],
  data() {
    return {
      alternativasText: this.convertAlternativasToText(
        this.pergunta.alternativas || []
      ),
      tiposComAlternativas: ["RADIO", "CHECKBOX", "SELECT", "MULTISELECT"],
      codeOptions: {
        lineNumbers: true,
        mode: "text",
        theme: "monokai",
        lineWrapping: true,
      },
    };
  },
  watch: {
    alternativasText(newVal) {
      this.pergunta.alternativas = this.convertTextToAlternativas(newVal);
    },
    "pergunta.tipo"(newTipo) {
      if (this.tiposComAlternativas.includes(newTipo) && this.pergunta) {
        this.alternativasText = "";
        this.pergunta.alternativas = [];
      }
    },
  },
  methods: {
    convertAlternativasToText(alternativas) {
      return alternativas.map((alt) => alt.descricao).join("\n");
    },
    convertTextToAlternativas(text) {
      return text
        .split("\n")
        .filter((line) => line.trim() !== "")
        .map((desc) => ({
          descricao: desc.trim(),
          // ordem: index
        }));
    },
  },
};
</script>

<style scoped>
.hint {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
</style>
